/* eslint-disable react/prop-types */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { UserService } from "services/userService";

export default function ActionCell({ item, setDataTable }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      await UserService.delete(item?._id);
      setDataTable((prev) => ({ ...prev, rows: prev.rows.filter((row) => row.id !== item?._id) }));
      handleClose();
      toast.success("Xoá thành công");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Xoá thất bại");
      console.error({ error });
      handleClose();
    }
  };
  return (
    <div>
      <SoftBox display="flex" alignItems="center">
        <SoftTypography
          onClick={handleClickOpen}
          variant="body1"
          color="success"
          sx={{ cursor: "pointer", lineHeight: 0 }}
        >
          <Tooltip title="Xóa user" placement="top">
            <Icon color="error">delete</Icon>
          </Tooltip>
        </SoftTypography>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Xóa user {item.email} ?</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Bạn có chắc chắn muốn xóa?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Hủy</Button>
            <Button onClick={handleDelete} autoFocus>
              Đồng ý
            </Button>
          </DialogActions>
        </Dialog>
      </SoftBox>
    </div>
  );
}
